export default __webpack_public_path__ + "static/media/bosch_ui_icon_rtl.5b09fa55.woff2";